import { createFileRoute } from '@tanstack/react-router'
import { PasswordRecovery } from '@/components/auth/password-recovery/password-recovery'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'

export const Route = createFileRoute('/_auth/forgot-password')({
  validateSearch: zodValidator(z.object({ redirect: z.string().optional() })),
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  return <PasswordRecovery />
}
